module.exports = (val, treshold = 34, symbol = '...') => {
  val = String(val)
  return val.length < treshold
    ? val
    : val.slice(0, treshold - symbol.length).trimEnd() + symbol
}
